<template>
  <div style="width:100%">
    <input
      v-model="value"
      :type="passwordFieldType"
      class="form-control"
    >
    <span
      class="fa fa-fw fa-eye field-icon toggle-password"
      @click="switchVisibility"
    />
  </div>
</template>

<script>
   import { abstractField } from "vue-form-generator";
   export default {
          components: { },
         mixins: [ abstractField ],
         data() {
             return{
                 passwordFieldType: "password"
             }
         },
         methods:{
            switchVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            }
         }
   };
</script>

<style scoped>
    .field-icon {
        cursor: pointer;
        float: right;
        padding-right: 25px;
        margin-top: -25px;
        position: relative;
        z-index: 2;
    }
</style>